span{color:#232426de}
/*# sourceMappingURL=persist-checkbox.component.css.map */
